import { Button } from '../components/ui';
import { navigate } from '../router';

/** Path sem tela no app do tenant (link antigo ou digitado errado). */
export function NaoEncontrada() {
  return (
    <div>
      <p className="muted">O endereço aberto não corresponde a nenhuma tela do seu condomínio.</p>
      <Button onClick={() => navigate('/')}>Ir para o Início</Button>
    </div>
  );
}
